import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//

import { debounce } from "lodash";
import AutocompleteInput from "./autocomplete-input.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AddressInput",
  components: {
    AutocompleteInput
  },
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      defaultAddress: {
        "formatted-address": "",
        "street-number": "",
        "street-name": "",
        city: "",
        province: "",
        "postal-code": "",
        "unit-number": ""
      }
    };
  },
  computed: {
    valueModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("change", _objectSpread(_objectSpread({}, this.defaultAddress), value));
      }
    },
    addressString() {
      var _this$valueModel$form, _this$valueModel;
      return (_this$valueModel$form = (_this$valueModel = this.valueModel) == null ? void 0 : _this$valueModel["formatted-address"]) != null ? _this$valueModel$form : "";
    }
  },
  methods: {
    handleChange: debounce(function (addressInformation) {
      if (typeof addressInformation === "string") {
        this.valueModel = {
          "formatted-address": addressInformation
        };
      } else {
        this.valueModel = addressInformation;
      }
    }, 50)
  }
});